import { Dictionary } from '@utils/util.types';
import { create } from 'zustand';

interface SpecialtiesStore {
	specialties: Dictionary[];
	setSpecialties: (specialties: Dictionary[]) => void;
}

export const useSpecialtiesStore = create<SpecialtiesStore>((set) => ({
	specialties: [],
	setSpecialties: (specialties) => set({ specialties }),
}));
